import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "16px !important",
    height: "16px !important",
    "& svg": {
      width: "16px !important",
      height: "16px !important",
      color: theme.palette.primary.main,
    },
  },
}));
